// extracted by mini-css-extract-plugin
export default {"banner-between-questions":"L2ej8WZPafxJLebsDoUb","bannerBetweenQuestions":"L2ej8WZPafxJLebsDoUb"};